import React from 'react';
import {StyleSheet, View, Text, StyleProp, ViewStyle} from 'react-native';
import {colors} from 'src/assets';
import {Icon} from 'src/components';

export type RatingProps = {
  containerStyle?: StyleProp<ViewStyle>;
  value: number;
};

export const Rating: React.FC<RatingProps> = ({containerStyle, value}) => {
  return (
    <View style={[styles.container, containerStyle]}>
      <View style={styles.stars}>
        <Icon
          name={value > 0 ? 'star-filled' : 'star'}
          size={16}
          color={value > 0 ? colors.chokuRed : colors.chokuGray6}
          style={styles.star}
        />
        <Icon
          name={value > 1 ? 'star-filled' : 'star'}
          size={16}
          color={value > 1 ? colors.chokuRed : colors.chokuGray6}
          style={styles.star}
        />
        <Icon
          name={value > 2 ? 'star-filled' : 'star'}
          size={16}
          color={value > 2 ? colors.chokuRed : colors.chokuGray6}
          style={styles.star}
        />
        <Icon
          name={value > 3 ? 'star-filled' : 'star'}
          size={16}
          color={value > 3 ? colors.chokuRed : colors.chokuGray6}
          style={styles.star}
        />
        <Icon
          name={value > 4 ? 'star-filled' : 'star'}
          size={16}
          color={value > 4 ? colors.chokuRed : colors.chokuGray6}
          style={styles.star}
        />
      </View>
      <Text style={styles.rating}>{value}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  stars: {
    flexDirection: 'row',
  },
  star: {
    marginRight: 1,
  },
  rating: {
    marginLeft: 8,
    fontSize: 15,
    fontWeight: 'bold',
    color: colors.chokuRed,
  },
});
